import PlayerIcon from "./player-icon";
export default function PlayerAnimation(playerName, iconArray, offset = 0) {
  const element = document.createElement("div");
  element.classList.add("animation");
  const frames = [];
  iconArray.forEach(iconName => {
    const frame = PlayerIcon(playerName, iconName);
    frame.style.visibility = "hidden";
    frames.push(frame);
    element.appendChild(frame);
  });
  const size = calcMaxSize(frames);
  element.style.width = `${size.width}px`;
  element.style.height = `${size.height}px`;
  let currentIndex = -1;
  next();
  function next() {
    if (currentIndex >= 0) frames[currentIndex].style.visibility = "hidden";else currentIndex = offset - 1;
    currentIndex++;
    if (currentIndex >= frames.length) currentIndex = 0;
    frames[currentIndex].style.visibility = "visible";
    setTimeout(next, 50);
  }
  return element;
}
function calcMaxSize(frames) {
  let maxWidth = 0,
    maxHeight = 0;
  frames.forEach(frame => {
    maxWidth = Math.max(maxWidth, frame.sprite.width);
    maxHeight = Math.max(maxHeight, frame.sprite.height);
  });
  return {
    width: maxWidth,
    height: maxHeight
  };
}